import React, { useEffect, useRef, useState } from 'react';

/**
 * Reveals its content once it scrolls into view.
 * `stagger` walks the direct children in one after another.
 */
export default function Reveal({ children, stagger = false, delay = 0, className = '', as: Tag = 'div' }) {
    const ref = useRef(null);
    const [shown, setShown] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || typeof IntersectionObserver === 'undefined') {
            setShown(true);
            return;
        }

        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setShown(true);
                    io.disconnect();
                }
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
        );

        io.observe(el);
        return () => io.disconnect();
    }, []);

    return (
        <Tag
            ref={ref}
            className={`${stagger ? 'reveal-stagger' : 'reveal'} ${shown ? 'in' : ''} ${className}`}
            style={delay ? { transitionDelay: `${delay}ms` } : undefined}
        >
            {children}
        </Tag>
    );
}
